/* AMC mobile category navigation v5, 2026-10-10.
   Swipe-only product rows; retain the existing red Shop all category links.
   No new controls, click interception, requests, or autoplay timers. */
(() => {
  'use strict';
  const key = '__amcMobileRowNavigation';
  if (window[key]?.version === 5) { window[key].refresh(); return; }
  window[key]?.destroy?.();

  const mobile = window.matchMedia('(max-width:749px)');
  const legacy = '.amc-market-hub__panel .amc-featured-controls, .amc-equipment-category .amc-equipment-category__controls';
  const obsolete = '.amc-mobile-collection-controls';
  const saved = new Map();
  let started = false;

  function conceal(control) {
    if (!mobile.matches || !control.isConnected) return;
    if (!control.hidden) control.hidden = true;
    if (control.style.getPropertyValue('display') !== 'none' ||
        control.style.getPropertyPriority('display') !== 'important') {
      control.style.setProperty('display', 'none', 'important');
    }
  }
  // The older carousel writes display:flex!important on resize. Watch only
  // its controls, and write only when needed to avoid observer feedback loops.
  const attributes = new MutationObserver(records => {
    if (!mobile.matches) return;
    const changed = new Set(records.map(record => record.target));
    changed.forEach(control => { if (saved.has(control)) conceal(control); });
  });

  function remember(control) {
    if (!mobile.matches || !control.closest('#MainContent')) return;
    if (!saved.has(control)) {
      saved.set(control, {
        display: control.style.getPropertyValue('display'),
        priority: control.style.getPropertyPriority('display'),
        hidden: control.getAttribute('hidden')
      });
      attributes.observe(control, {attributes:true, attributeFilter:['style','hidden']});
    }
    conceal(control);
  }

  function restore() {
    attributes.disconnect();
    saved.forEach((before, control) => {
      if (control.style.getPropertyValue('display') === 'none' &&
          control.style.getPropertyPriority('display') === 'important') {
        if (before.display) control.style.setProperty('display', before.display, before.priority);
        else control.style.removeProperty('display');
      }
      if (before.hidden === null) control.removeAttribute('hidden');
      else control.setAttribute('hidden', before.hidden);
    });
    saved.clear();
  }

  function scan(scope = document) {
    if (!mobile.matches) return;
    if (scope.matches?.(obsolete) && scope.closest('#MainContent')) { scope.remove(); return; }
    scope.querySelectorAll?.(obsolete).forEach(control => {
      if (control.closest('#MainContent')) control.remove();
    });
    if (scope.matches?.(legacy)) remember(scope);
    scope.querySelectorAll?.(legacy).forEach(remember);
  }

  const children = new MutationObserver(records => {
    if (!mobile.matches) return;
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1) scan(node);
    }));
  });

  function refresh() {
    if (mobile.matches) scan();
    else restore();
  }
  function sectionLoaded(event) {
    if (mobile.matches) scan(event.target);
    document.querySelectorAll('#MainContent').forEach(main => {
      children.observe(main, {childList:true, subtree:true});
    });
  }
  function sectionUnloaded(event) {
    saved.forEach((before, control) => {
      if (event.target.contains(control)) saved.delete(control);
    });
    attributes.disconnect();
    if (mobile.matches) saved.forEach((before, control) => {
      if (control.isConnected) attributes.observe(control, {attributes:true, attributeFilter:['style','hidden']});
      else saved.delete(control);
    });
  }
  function start() {
    if (started) return;
    started = true;
    document.querySelectorAll('#MainContent').forEach(main => {
      children.observe(main, {childList:true, subtree:true});
    });
    refresh();
  }

  mobile.addEventListener('change', refresh);
  document.addEventListener('shopify:section:load', sectionLoaded);
  document.addEventListener('shopify:section:unload', sectionUnloaded);
  window[key] = {version:5, mode:'swipe-only', refresh, destroy() {
    children.disconnect();
    restore();
    mobile.removeEventListener('change', refresh);
    document.removeEventListener('DOMContentLoaded', start);
    document.removeEventListener('shopify:section:load', sectionLoaded);
    document.removeEventListener('shopify:section:unload', sectionUnloaded);
  }};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
